import React from 'react';
import { useSelector } from 'react-redux';
import { Redirect, Route } from 'react-router-dom';

const GuestGuard = ({ component: Component, ...rest }) => {
  const { isAuth } = useSelector((state) => state.admin);

  return (
    <Route
      {...rest}
      render={(props) =>
        !isAuth ? <Component {...props} /> : <Redirect to="/" />
      }
    />
  );
};

export default GuestGuard;